module.exports = __webpack_public_path__ + "assets/media/google.53c10b98.svg";